import moment, { Moment } from 'moment';
import { useTranslations } from '@lang';
import { YourStayContainer, YourStayLabel, YourStayDates } from './YourStayBanner.styles';

interface YourStayBannerProps {
  fromDate: string | Moment;
  toDate: string | Moment;
}

export const YourStayBanner = ({ fromDate, toDate }: YourStayBannerProps) => {
  const { t } = useTranslations();

  return (
    <YourStayContainer>
      <YourStayLabel>{t('overnightPackage.yourStay')}:</YourStayLabel>
      <YourStayDates>
        {moment(fromDate).format('D MMM YYYY')} → {moment(toDate).format('D MMM YYYY')}
      </YourStayDates>
    </YourStayContainer>
  );
};
